import { useEffect, useState } from 'react';
import { Button, Card } from '../components/ui/primitives';
import { Wordmark } from '../layouts/AppShell';
import { usePublicConfig } from '../selfservice/usePublicConfig';
import { PrivacyContent, TermsContent } from './InfoContent';

// P-085 · páginas PÚBLICAS del aviso de privacidad (`#privacidad`) y de los términos (`#terminos`), para poder
// enlazarlas desde un correo o un mensaje. Sin sesión. Mismo contenido que el diálogo de información.

export const INFO_HASHES = ['privacidad', 'terminos'] as const;

export function isInfoHash(hash: string): boolean {
  const first = hash.replace(/^#/, '').split('?')[0].split('/')[0];
  return (INFO_HASHES as readonly string[]).includes(first);
}

const goBack = () => {
  if (window.history.length > 1) window.history.back();
  else window.location.hash = '';
};

export function InfoApp() {
  const { config } = usePublicConfig();
  const support = config?.support ?? null;
  // Pasar de una página a la otra cambia solo el hash (mismo shell): hay que escucharlo (lo encontró el E2E).
  const [hash, setHash] = useState(() => window.location.hash);
  useEffect(() => {
    const onHash = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHash);
    return () => window.removeEventListener('hashchange', onHash);
  }, []);
  const privacy = hash.replace(/^#/, '').startsWith('privacidad');
  return (
    <main className="n3-onb">
      <div className="n3-onb__column">
        <div className="n3-onb__brand"><Wordmark /></div>
        <Card aria-labelledby="info-title" as="section" className="n3-onb__panel">
          <h1 className="n3-onb__title" id="info-title">{privacy ? 'Aviso de privacidad' : 'Términos de uso'}</h1>
          <div className="n3-onb-info">
            {privacy ? <PrivacyContent support={support} /> : <TermsContent support={support} />}
          </div>
          <div className="n3-onb__actions"><Button fullWidth onClick={goBack} variant="secondary">Volver</Button></div>
        </Card>
      </div>
    </main>
  );
}
